import React from 'react';

import {
  createConnectedRouter,
  createRender,
} from 'found';
import Error from '../page/error';

const Router = createConnectedRouter({
  render: createRender({
    renderError: ({ error }) => ( // eslint-disable-line react/prop-types
      <div>
        {error.status === 404 ? <Error/> : 'Error'}
      </div>
    ),
  }),
});

export default Router;
